import { render, staticRenderFns } from "./Awaiting.vue?vue&type=template&id=1940a21a&"
import script from "./Awaiting.vue?vue&type=script&lang=js&"
export * from "./Awaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports